import React from 'react';
import { Countdown } from './Countdown';
import { OfferCard } from './OfferCard';
import { pricing } from '../data/pricing';
interface OfferProps {
  countdownHours: number;
}
export function Offer({
  countdownHours
}: OfferProps) {
  return <section id="oferta" className="scroll-mt-4 bg-teal-900 py-10 text-cream-50 sm:py-20" data-id="element-171" data-mp="1mmqze89blrqt">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-172" data-mp="1hoxste43uvq0">
        <div className="flex flex-wrap items-center justify-center gap-2 text-center" data-id="element-173" data-mp="tybljp1xdfh2">
          <p className="inline-flex items-center rounded-full bg-gold-500 px-3 py-1 font-display text-[0.65rem] font-800 uppercase tracking-[0.16em] text-teal-900 sm:px-4 sm:py-1.5 sm:text-xs sm:tracking-[0.18em]" data-id="element-174" data-mp="p00c3ffjl6zd">
            Oferta especial
          </p>
          <p className="font-display text-[0.65rem] font-700 uppercase tracking-[0.14em] text-cream-100/60 sm:text-sm sm:tracking-[0.16em]" data-id="element-175" data-mp="ywd7chqqjsw8">
            {pricing.crossed} después
          </p>
        </div>

        <div className="mt-5 sm:mt-8" data-id="element-176" data-mp="2actqom5eutod">
          <Countdown hours={countdownHours} label="El precio promocional termina en" data-id="element-177" data-mp="pkh4r5ywamdk" />
        </div>

        <h2 className="mt-7 text-center font-display text-2xl font-800 leading-tight sm:mt-12 sm:text-4xl" data-id="element-178" data-mp="uj1zwqzaifv5">
          Elegí tu Mega Pack Acompañante
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-center text-[0.8rem] text-cream-100/75 sm:mt-3 sm:text-base" data-id="element-179" data-mp="zgafqkwyu7t8">
          Todo lo que necesitás para tener actividades listas y organizadas.
        </p>

        <div className="mt-5 sm:mt-10" data-id="element-180" data-mp="6rmrcggx72bg">
          <OfferCard headingLevel="h3" data-id="element-181" data-mp="bsas3tuyaxiv" />
        </div>
      </div>
    </section>;
}